import {
  FETCH_DATA,
  FETCH_MENU,
  FETCH_METADATA,
  UPLOAD_MEDIA,
  CLEAR_REVIEW_MESSAGE,
  AUDIT_REVIEW_DATA,
  UPDATE_DATA,
  CLEAR_UPDATE_MESSAGE,
  DOWNLOAD_TEMPLATE,
  CLEAR_DOWNLOAD_TEMPLATE,
  SUMMARY_DATA,
  USER_LIST,
  APPROVE_MULTI_BATCH,
  DOWNLOAD_EXCEL_TEMPLATE
} from "./types";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA:
      return {
        ...state,
        reviewList: action.payload,
      };
    case UPLOAD_MEDIA:
      return {
        ...state,
        media: action.payload,
      };
    case UPDATE_DATA:
      return {
        ...state,
        updateData: action.payload,
      };
    case CLEAR_UPDATE_MESSAGE:
      return {
        ...state,
        updateData: {
          ...state.media,
          message: "",
          data: null,
          status: null,
          loader:false
        },
      };
    case CLEAR_REVIEW_MESSAGE:
      return {
        ...state,
        media: {
          ...state.media,
          message: "",
          data: null,
          status: null,
        },
      };
    case FETCH_MENU:
      return {
        ...state,
        menuItem: action.payload,
      };
    case FETCH_METADATA:
      return {
        ...state,
        metaData: action.payload,
      };
    case AUDIT_REVIEW_DATA:
      return {
        ...state,
        audit_logs: action.payload,
      };
    case DOWNLOAD_TEMPLATE:
      return {
        ...state,
        downloadTemp: action.payload,
      };
    case SUMMARY_DATA:
      return {
        ...state,
        summaryList: action.payload,
      };
    case USER_LIST:
      return {
        ...state,
        userList: action.payload,
      };
    case APPROVE_MULTI_BATCH:
      return {
        ...state,
        approveMulti: action.payload,
      };
    case DOWNLOAD_EXCEL_TEMPLATE:
      return {
        ...state,
        donwloadExcel: action.payload,
      };
    case CLEAR_DOWNLOAD_TEMPLATE:
      return {
        ...state,
        downloadTemp: {
          ...state.media,
          message: "",
          data: null,
          status: null,
        },
      };
    default:
      return state;
  }
};
export default reducer;
